'use client';

import React from 'react';
import ReactDOM from 'react-dom';
import { Card } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { LogOut } from 'lucide-react';

interface LeaveEventModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  eventTitle?: string;
  isLoading?: boolean;
}

export const LeaveEventModal: React.FC<LeaveEventModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  eventTitle,
  isLoading = false
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
      onClick={(e) => e.stopPropagation()}
    >
      <Card className="w-full max-w-md mx-4 p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex flex-col items-center text-center">
          {/* Icon */}
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <LogOut className="w-8 h-8 text-gray-600" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Leave event?
          </h2>

          {/* Description */}
          <p className="text-gray-600 mb-6 leading-relaxed">
            {eventTitle ? (
              <>
                Are you sure you want to stop attending <span className="font-medium text-gray-900">"{eventTitle}"</span>?
              </>
            ) : (
              'Are you sure you want to stop attending this event?'
            )}
          </p>

          {/* Action Buttons */}
          <div className="w-full space-y-3">
            <Button
              onClick={(e) => { e.stopPropagation(); onConfirm(); }}
              disabled={isLoading}
              className="w-full bg-accent text-white hover:bg-accent/90 py-3"
            >
              {isLoading ? 'Leaving…' : 'Leave event'}
            </Button>
            
            <Button
              variant="outline"
              onClick={(e) => { e.stopPropagation(); onClose(); }}
              disabled={isLoading}
              className="w-full py-3"
            >
              Cancel
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );

  if (typeof document !== 'undefined') {
    return ReactDOM.createPortal(modalContent, document.body);
  }

  return modalContent;
};


